
import { defineComponent, onBeforeUnmount, onMounted, ref } from "vue";

interface Orb {
  x: string;
  y: string;
  s: string;
  a: number;
  variant: string;
}

export default defineComponent({
  name: "AuthLayout",
  setup() {
    const shell = ref<HTMLElement | null>(null);
    const dotField = ref<SVGSVGElement | null>(null);

    const orbs: Orb[] = [
      { x: "14%", y: "18%", s: "760px", a: 0.55, variant: "" },
      { x: "88%", y: "22%", s: "480px", a: 0.5, variant: "" },
      { x: "96%", y: "58%", s: "540px", a: 0.65, variant: "orb-bright" },
      { x: "12%", y: "78%", s: "460px", a: 0.5, variant: "" },
      { x: "36%", y: "92%", s: "320px", a: 0.42, variant: "" },
      { x: "50%", y: "50%", s: "620px", a: 0.22, variant: "orb-gold" },
    ];

    // Grid 48×27 de puntos sobre el viewBox 1600×900.
    const stepX = 1600 / 47;
    const stepY = 900 / 26;
    const dots: { x: number; y: number }[] = [];
    for (let row = 0; row < 27; row++) {
      for (let col = 0; col < 48; col++) {
        dots.push({
          x: Math.round(col * stepX),
          y: Math.round(row * stepY),
        });
      }
    }

    let rafId = 0;
    let pendingPoint: { x: number; y: number } | null = null;
    let listenersAttached = false;

    const applyPointer = () => {
      rafId = 0;
      const svg = dotField.value;
      if (!svg || !pendingPoint) return;
      const ctm = svg.getScreenCTM();
      if (!ctm) return;
      const pt = svg.createSVGPoint();
      pt.x = pendingPoint.x;
      pt.y = pendingPoint.y;
      const local = pt.matrixTransform(ctm.inverse());
      svg.style.setProperty("--mx", String(local.x));
      svg.style.setProperty("--my", String(local.y));
    };

    const onMouseMove = (event: MouseEvent) => {
      pendingPoint = { x: event.clientX, y: event.clientY };
      if (!rafId) rafId = requestAnimationFrame(applyPointer);
    };

    const onMouseLeave = () => {
      pendingPoint = null;
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = 0;
      }
      const svg = dotField.value;
      if (svg) {
        svg.style.setProperty("--mx", "-9999");
        svg.style.setProperty("--my", "-9999");
      }
    };

    onMounted(() => {
      const reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;
      const smallViewport = window.matchMedia("(max-width: 768px)").matches;
      if (reducedMotion || smallViewport) return;
      const el = shell.value;
      if (!el) return;
      el.addEventListener("mousemove", onMouseMove);
      el.addEventListener("mouseleave", onMouseLeave);
      listenersAttached = true;
    });

    onBeforeUnmount(() => {
      if (rafId) cancelAnimationFrame(rafId);
      const el = shell.value;
      if (el && listenersAttached) {
        el.removeEventListener("mousemove", onMouseMove);
        el.removeEventListener("mouseleave", onMouseLeave);
      }
    });

    return { shell, dotField, orbs, dots };
  },
});
